import _ from 'lodash';
import dayjs from 'dayjs';
import { CreatePjmRegistrationDto, PjmRegistrationDto, UpdatePjmRegistrationDto } from 'src/domain/pjm/dto/PjmRegistrationDto';
import { PJM_TZ } from '../../../../../domain/pjm';

export interface PjmRegistrationForm extends PjmRegistrationDto {}

export class PjmRegistrationTransformer {
    static toFormValues(data: PjmRegistrationDto): PjmRegistrationForm {
        const form: PjmRegistrationForm = {
            ...data,
        };

        if (form.summaryInfo?.startDate) {
            const startDate = dayjs(form.summaryInfo.startDate).tz(PJM_TZ);

            // @ts-expect-error
            form.summaryInfo.startDate = startDate.isValid() ? startDate : dayjs.tz(PJM_TZ);
        }

        if (form.summaryInfo?.endDate) {
            const endDate = dayjs(form.summaryInfo.endDate).tz(PJM_TZ);

            // @ts-expect-error
            form.summaryInfo.endDate = endDate.isValid() ? endDate : dayjs.tz(PJM_TZ);
        }

        return form;
    }

    static toCreateDto(data: PjmRegistrationForm): CreatePjmRegistrationDto {
        const dto: CreatePjmRegistrationDto = {
            locationUuid: data.locationUuid,
            summaryInfo: {
                name: data.summaryInfo.name,
                program: data.summaryInfo.program,
                startDate: new Date(data.summaryInfo.startDate!),
                endDate: new Date(data.summaryInfo.endDate!),
                CSP: {
                    name: data.summaryInfo.CSP?.name,
                },
                EDC: {
                    name: data.summaryInfo.EDC?.name,
                    accountNo: data.summaryInfo.EDC?.accountNo,
                },
                ...(data.summaryInfo.LSE?.name
                    ? {
                          LSE: {
                              name: data.summaryInfo.LSE?.name,
                          },
                      }
                    : {}),
                zone: data.summaryInfo.zone,
                pricingPoint: data.summaryInfo.pricingPoint,
                status: data.summaryInfo.status,
                dispatchGroup: data.summaryInfo.dispatchGroup,
                completed: data.summaryInfo.completed,
                testRequired: data.summaryInfo.testRequired,
                residential: data.summaryInfo.residential,
                ...(data.summaryInfo.residential
                    ? {
                          residentialProgramType: data.summaryInfo.residentialProgramType,
                          loadDataSample: data.summaryInfo.loadDataSample,
                          sampleNumberParticipants: data.summaryInfo.sampleNumberParticipants,
                      }
                    : {
                          residentialProgramType: null,
                          loadDataSample: null,
                          sampleNumberParticipants: null,
                      }),
                underDuplicateReview: data.summaryInfo.underDuplicateReview,
            },
            locationSummaryInfo: _.cloneDeep(data.locationSummaryInfo!),
            locationInfo: _.cloneDeep(data.locationInfo),
            energyInfo: _.cloneDeep(data.energyInfo),
            capacityInfo: _.cloneDeep(data.capacityInfo),
            cblMethodInfo: _.cloneDeep(data.cblMethodInfo), //?
            priceResponsiveDemandInfo: _.cloneDeep(data.priceResponsiveDemandInfo),
            generatorCostInfo: _.cloneDeep(data.generatorCostInfo),
            regCblParameters: _.cloneDeep(data.regCblParameters), //?
            otherInfo: _.cloneDeep(data.otherInfo),
            comments: _.cloneDeep(data.comments),
        };

        return dto;
    }

    static toUpdateDto(data: PjmRegistrationForm): UpdatePjmRegistrationDto {
        const dto: UpdatePjmRegistrationDto = {
            // uuid: data.uuid,
            summaryInfo: {
                name: data.summaryInfo.name,
                program: data.summaryInfo.program,
                startDate: new Date(data.summaryInfo.startDate!),
                endDate: new Date(data.summaryInfo.endDate!),
                CSP: {
                    name: data.summaryInfo.CSP?.name,
                },
                EDC: {
                    name: data.summaryInfo.EDC?.name,
                    accountNo: data.summaryInfo.EDC?.accountNo,
                },
                ...(data.summaryInfo.LSE?.name
                    ? {
                          LSE: {
                              name: data.summaryInfo.LSE?.name,
                          },
                      }
                    : {}),
                zone: data.summaryInfo.zone,
                pricingPoint: data.summaryInfo.pricingPoint,
                status: data.summaryInfo.status,
                dispatchGroup: data.summaryInfo.dispatchGroup,
                completed: data.summaryInfo.completed,
                testRequired: data.summaryInfo.testRequired,
                residential: data.summaryInfo.residential,
                ...(data.summaryInfo.residential
                    ? {
                          residentialProgramType: data.summaryInfo.residentialProgramType,
                          loadDataSample: data.summaryInfo.loadDataSample,
                          sampleNumberParticipants: data.summaryInfo.sampleNumberParticipants,
                      }
                    : {
                          residentialProgramType: null,
                          loadDataSample: null,
                          sampleNumberParticipants: null,
                      }),
                underDuplicateReview: data.summaryInfo.underDuplicateReview,
            },
            locationSummaryInfo: _.cloneDeep(data.locationSummaryInfo!),
            locationInfo: _.cloneDeep(data.locationInfo),
            energyInfo: _.cloneDeep(data.energyInfo),
            capacityInfo: _.cloneDeep(data.capacityInfo),
            cblMethodInfo: _.cloneDeep(data.cblMethodInfo), //?
            priceResponsiveDemandInfo: _.cloneDeep(data.priceResponsiveDemandInfo),
            generatorCostInfo: _.cloneDeep(data.generatorCostInfo),
            regCblParameters: _.cloneDeep(data.regCblParameters), //?
            otherInfo: _.cloneDeep(data.otherInfo),
            comments: _.cloneDeep(data.comments),
        };

        return dto;
    }
}
